// extracted by mini-css-extract-plugin
module.exports = {"control":"SiteMostReviewedShops_control__25xyF","arrow":"SiteMostReviewedShops_arrow__32g0S","slider":"SiteMostReviewedShops_slider__Rv4e6"};